// components.
import { useSelector } from 'react-redux';
import { AbortTaskModal } from '../FormActions/AbortTaskModal';

// hooks.
import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { useAbortTask } from './hooks/useAbortTask';

export const AbortTask = ({ taskAgent }: { taskAgent: string }) => {
  const email = useSelector(getEmail);
  const isSameAgent = taskAgent && taskAgent === email;

  const { handleOpenAbandonModal } = useAbortTask();

  if (isSameAgent) return null;

  return (
    <>
      <div
        className="text-danger fw-bold"
        onClick={handleOpenAbandonModal}
        role="button"
      >
        Reasignar
      </div>
      <AbortTaskModal />
    </>
  );
};
